/**
 * Configurateur Luminaire LED — moood
 *
 * Module indépendant qui se branche au configurateur général (configurateur-moood.js)
 * via window.mooodState et window.mooodGetTunnel exposés en bas du gros fichier.
 *
 * Aucune modification du gros fichier nécessaire.
 *
 * Comment ça marche :
 *  - On observe les clics sur la pill `.moood-etape[data-etape="luminaire"]`
 *  - Quand elle devient active, on prend le contrôle de #moood-products-sections
 *  - On affiche notre UI à 4 questions
 *  - Au clic "Ajouter au pack", on pousse les items dans window.mooodState.panier
 *  - Le configurateur général se charge du reste (affichage panier, ajout cart, etc.)
 */
(function() {
  'use strict';

  // ============================================================
  // CONFIGURATION (modifiable facilement)
  // ============================================================
  var ETAPE_HANDLE = 'luminaire';   // handle de la collection Shopify
  var MARGE_ALIM = 1.00;            // x1.00 = pas de marge
  var W_PAR_METRE = 8;              // 8W par metre lineaire de bandeau
  var LONGUEUR_BANDEAU_CM = 60;     // un bandeau vendu = 60cm
  var SEUIL_CONN_I_CM = 290;        // un connecteur I entre 2 profiles physiques de 290cm
  var CABLE_INCLUS_CM = 150;        // cable inclus avec le bandeau (1.5m)
  var CABLE_RALLONGE_CM = 150;      // longueur du cable rallonge optionnel (1.5m)

  var HANDLES = {
    bandeau_chaud:    'eclairage-lineaire-design-pour-cuisine-l60cm-blanc-chaud-2700k',
    bandeau_naturel:  'eclairage-lineaire-design-pour-cuisine-l60cm-blanc-naturel-4000k',
    detecteur_motion: 'detecteur-pour-luminaire-led-motion-de-surface-24v-dc',
    detecteur_tactile:'detecteur-pour-luminaire-led-24v-dc-allumage-par-interrupteur-tactile',
    connecteur_i:     'connecteur-i-pour-le-raccordement-du-luminaire-led',
    connecteur_l:     'connecteur-l-pour-le-raccordement-du-luminaire-led',
    cable_rallonge:   'cable-avec-connecteur-invisible-pour-luminaire-led',
    alim_15:          'alimentation-compacte-pour-eclairage-led-smart-24v-dc-15w',
    alim_30:          'alimentation-compacte-pour-eclairage-led-smart-24v-dc-30w',
    alim_60:          'alimentation-compacte-pour-eclairage-led-smart-24v-dc-60w',
    alim_90:          'alimentation-compacte-pour-eclairage-led-smart-24v-dc-90w',
    alim_150:         'alimentation-compacte-pour-eclairage-led-smart-24v-dc-150w'
  };

  var ALIMS = [
    { w: 15,  handle: HANDLES.alim_15 },
    { w: 30,  handle: HANDLES.alim_30 },
    { w: 60,  handle: HANDLES.alim_60 },
    { w: 90,  handle: HANDLES.alim_90 },
    { w: 150, handle: HANDLES.alim_150 }
  ];

  // ============================================================
  // CACHE PRODUITS
  // ============================================================
  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error('Produit introuvable : ' + handle); return r.json(); })
      .then(function(p) {
        productCache[handle] = {
          id: p.id,
          title: p.title,
          price: p.price,
          variantId: p.variants && p.variants[0] ? p.variants[0].id : null,
          handle: handle,
          image: p.featured_image || (p.images && p.images[0]) || ''
        };
        return productCache[handle];
      });
  }
  function preloadAllProducts() {
    return Promise.all(Object.keys(HANDLES).map(function(k) {
      return fetchProduct(HANDLES[k]).catch(function() { return null; });
    }));
  }

  // ============================================================
  // FORMATAGE
  // ============================================================
  function fmtPrix(cents) {
    if (cents == null || isNaN(cents)) return '-';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  // ============================================================
  // STYLES INJECTES UNE SEULE FOIS
  // ============================================================
  function injectStyles() {
    if (document.getElementById('moo-lumi-styles')) return;
    var st = document.createElement('style');
    st.id = 'moo-lumi-styles';
    st.textContent = ''
      + '.moo-lumi { --moo-terracotta:#C4622A; --moo-ocre:#DFAE3A; --moo-ink:#12312b; --moo-ink-2:#174E44; --moo-cream:#fff8ed; --moo-cream-2:#fff3e4; --moo-muted:#6f7f7b; max-width:1100px; margin:0 auto; }'
      + '.moo-lumi * { box-sizing:border-box; }'
      + '.moo-lumi__hero { margin:0 0 24px; display:grid; grid-template-columns:repeat(3,1fr); gap:12px; }'
      + '.moo-lumi__hero img { width:100%; height:auto; display:block; aspect-ratio:4/3; object-fit:cover; border:2px solid var(--moo-ink); border-radius:18px; box-shadow:6px 6px 0 0 var(--moo-ocre); transition:transform .25s ease, box-shadow .25s ease; }'
      + '.moo-lumi__hero img:hover { transform:translate(-3px,-3px); box-shadow:9px 9px 0 0 var(--moo-terracotta); }'
      + '@media (max-width:700px) { .moo-lumi__hero { grid-template-columns:1fr; gap:10px; } .moo-lumi__hero img { aspect-ratio:16/9; box-shadow:4px 4px 0 0 var(--moo-ocre); } }'
      + '.moo-lumi__notice { display:flex; align-items:flex-start; gap:14px; margin:0 0 24px; padding:14px 18px; background:var(--moo-cream-2); border:2px solid var(--moo-ink); border-radius:14px; }'
      + '.moo-lumi__notice-icon { flex-shrink:0; width:36px; height:36px; border-radius:50%; background:var(--moo-terracotta); color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:18px; }'
      + '.moo-lumi__notice-text { font-size:14px; line-height:1.5; color:var(--moo-ink); }'
      + '.moo-lumi__notice-text strong { font-weight:700; }'
      + '.moo-lumi__layout { display:grid; grid-template-columns:1fr; gap:24px; }'
      + '.moo-lumi__step { background:#fff; border:2px solid var(--moo-ink); border-radius:18px; padding:24px; margin-bottom:24px; }'
      + '.moo-lumi__step h3 { display:flex; align-items:center; gap:12px; margin:0 0 14px; }'
      + '.moo-lumi__step-num { display:inline-flex; align-items:center; justify-content:center; width:32px; height:32px; flex-shrink:0; border-radius:50%; background:var(--moo-terracotta); color:#fff; font-weight:700; font-size:15px; line-height:1; }'
      + '.moo-lumi__step-title { font-size:18px; font-weight:600; color:var(--moo-ink); line-height:1.2; }'
      + '.moo-lumi__system { background:#fff; border:2px solid var(--moo-ink); border-radius:18px; padding:24px; margin-bottom:24px; }'
      + '.moo-lumi__system-header { display:flex; align-items:center; gap:12px; margin-bottom:20px; padding-bottom:16px; border-bottom:2px solid var(--moo-cream-2); }'
      + '.moo-lumi__system-badge { display:inline-flex; align-items:center; justify-content:center; padding:6px 14px; background:var(--moo-ink); color:#fff; border-radius:999px; font-weight:700; font-size:13px; text-transform:uppercase; letter-spacing:.5px; flex-shrink:0; }'
      + '.moo-lumi__system-title { font-size:18px; font-weight:600; color:var(--moo-ink); margin:0; }'
      + '.moo-lumi__field { margin-bottom:20px; padding-bottom:20px; border-bottom:1px solid var(--moo-cream-2); }'
      + '.moo-lumi__field:last-child { margin-bottom:0; padding-bottom:0; border-bottom:none; }'
      + '.moo-lumi__field-label { display:block; font-weight:600; color:var(--moo-ink); margin-bottom:10px; font-size:15px; }'
      + '.moo-lumi__inputwrap { position:relative; max-width:260px; }'
      + '.moo-lumi__input { width:100%; padding:14px 60px 14px 16px; font-size:18px; font-weight:600; border:2px solid var(--moo-ink); border-radius:12px; background:var(--moo-cream); color:var(--moo-ink); font-family:inherit; outline:none; -moz-appearance:textfield; }'
      + '.moo-lumi__input::-webkit-outer-spin-button, .moo-lumi__input::-webkit-inner-spin-button { -webkit-appearance:none; margin:0; }'
      + '.moo-lumi__input:focus { border-color:var(--moo-terracotta); box-shadow:0 0 0 3px rgba(196,98,42,.15); }'
      + '.moo-lumi__unit { position:absolute; right:16px; top:50%; transform:translateY(-50%); font-size:14px; font-weight:600; color:var(--moo-muted); pointer-events:none; }'
      + '.moo-lumi__hint { display:block; margin-top:8px; font-size:13px; color:var(--moo-muted); }'
      + '.moo-lumi__options { display:flex; flex-wrap:wrap; gap:18px; padding:4px 8px 12px 0; }'
      + '.moo-lumi__opt { flex:1 1 auto; min-width:200px; cursor:pointer; position:relative; }'
      + '.moo-lumi__opt input { position:absolute; opacity:0; pointer-events:none; }'
      + '.moo-lumi__opt-box { display:flex; align-items:center; justify-content:center; padding:14px 20px; border:2px solid var(--moo-ink); border-radius:999px; background:#fff; font-weight:600; font-size:15px; color:var(--moo-ink); text-align:center; min-height:52px; box-shadow:6px 6px 0 0 var(--moo-ocre); transition:transform .15s ease, box-shadow .15s ease, background .15s ease, color .15s ease, border-color .15s ease; }'
      + '.moo-lumi__opt:hover .moo-lumi__opt-box { transform:translate(-3px,-3px); box-shadow:9px 9px 0 0 var(--moo-terracotta); }'
      + '.moo-lumi__opt input:checked + .moo-lumi__opt-box { background:var(--moo-ink); color:#fff; border-color:var(--moo-ink); box-shadow:6px 6px 0 0 var(--moo-terracotta); }'
      + '.moo-lumi__chips { display:flex; flex-wrap:wrap; gap:8px; }'
      + '.moo-lumi__chip { cursor:pointer; position:relative; }'
      + '.moo-lumi__chip input { position:absolute; opacity:0; pointer-events:none; }'
      + '.moo-lumi__chip-box { display:inline-flex; align-items:center; justify-content:center; min-width:50px; padding:10px 16px; border:2px solid var(--moo-ink); border-radius:999px; background:#fff; font-weight:600; font-size:15px; color:var(--moo-ink); transition:all .15s ease; }'
      + '.moo-lumi__chip:hover .moo-lumi__chip-box { background:var(--moo-cream-2); }'
      + '.moo-lumi__chip input:checked + .moo-lumi__chip-box { background:var(--moo-terracotta); color:#fff; border-color:var(--moo-terracotta); }'
      + '.moo-lumi__recap-inline { background:var(--moo-ink); color:#fff; border-radius:18px; padding:24px; margin-top:24px; }'
      + '.moo-lumi__recap-title { font-size:18px; font-weight:700; margin:0 0 16px; color:#fff; }'
      + '.moo-lumi__recap-section { margin-bottom:16px; padding-bottom:12px; border-bottom:1px solid rgba(255,255,255,.15); }'
      + '.moo-lumi__recap-section:last-of-type { border-bottom:none; margin-bottom:0; padding-bottom:0; }'
      + '.moo-lumi__recap-section-title { font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:.5px; color:var(--moo-ocre); margin:0 0 8px; }'
      + '.moo-lumi__recap-list { list-style:none; padding:0; margin:0; }'
      + '.moo-lumi__recap-item { display:flex; justify-content:space-between; align-items:flex-start; gap:12px; padding:8px 0; font-size:14px; }'
      + '.moo-lumi__recap-name { flex:1; color:rgba(255,255,255,.9); line-height:1.4; }'
      + '.moo-lumi__recap-name strong { color:#fff; display:block; font-weight:600; }'
      + '.moo-lumi__recap-qty { color:rgba(255,255,255,.6); font-size:12px; display:block; margin-top:2px; }'
      + '.moo-lumi__recap-price { white-space:nowrap; font-weight:600; color:#fff; }'
      + '.moo-lumi__recap-note { margin:10px 0 0; padding:8px 10px; background:rgba(223,174,58,.15); border-left:2px solid var(--moo-ocre); border-radius:4px; font-size:11px; color:rgba(255,255,255,.85); line-height:1.4; }'
      + '.moo-lumi__recap-note strong { color:#fff; font-weight:700; }'
      + '.moo-lumi__recap-total { display:flex; justify-content:space-between; align-items:baseline; padding-top:16px; margin-top:16px; border-top:2px solid rgba(255,255,255,.25); font-size:18px; font-weight:700; color:#fff; }'
      + '.moo-lumi__recap-total-price { font-size:26px; color:var(--moo-terracotta); }'
      + '.moo-lumi__cta { width:100%; margin-top:20px; padding:16px; background:var(--moo-terracotta); color:#fff; border:2px solid var(--moo-terracotta); border-radius:50px; font-size:16px; font-weight:700; cursor:pointer; transition:all .15s ease; font-family:inherit; }'
      + '.moo-lumi__cta:hover:not(:disabled) { background:#b3561f; border-color:#b3561f; }'
      + '.moo-lumi__cta:disabled { opacity:.5; cursor:not-allowed; }'
      + '.moo-lumi__empty { text-align:center; color:rgba(255,255,255,.6); padding:20px 0; font-size:13px; }';
    document.head.appendChild(st);
  }

  // ============================================================
  // GENERATION HTML BLOC SYSTEME
  // ============================================================
  function htmlSysteme(num) {
    return ''+
      '<div class="moo-lumi__system" data-systeme="' + num + '">' +
        '<div class="moo-lumi__system-header">' +
          '<span class="moo-lumi__system-badge">Système ' + num + '</span>' +
          '<h3 class="moo-lumi__system-title">Décrivez cette zone d\'éclairage</h3>' +
        '</div>' +

        '<div class="moo-lumi__field">' +
          '<label class="moo-lumi__field-label">Longueur à éclairer</label>' +
          '<div class="moo-lumi__inputwrap">' +
            '<input type="number" class="moo-lumi__input moo-lumi__longueur" data-systeme="' + num + '" min="30" max="2000" step="1" placeholder="ex : 240" inputmode="numeric" />' +
            '<span class="moo-lumi__unit">cm</span>' +
          '</div>' +
          '<span class="moo-lumi__hint">Bandeau découpé sur mesure et livré à la taille exacte saisie (au mm près).</span>' +
        '</div>' +

        '<div class="moo-lumi__field">' +
          '<label class="moo-lumi__field-label">Combien d\'angles ?</label>' +
          '<div class="moo-lumi__chips moo-lumi__angles" data-systeme="' + num + '">' +
            '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-angles-' + num + '" value="0" checked><span class="moo-lumi__chip-box">0</span></label>' +
            '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-angles-' + num + '" value="1"><span class="moo-lumi__chip-box">1</span></label>' +
            '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-angles-' + num + '" value="2"><span class="moo-lumi__chip-box">2</span></label>' +
            '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-angles-' + num + '" value="3"><span class="moo-lumi__chip-box">3</span></label>' +
            '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-angles-' + num + '" value="4"><span class="moo-lumi__chip-box">4</span></label>' +
          '</div>' +
          '<span class="moo-lumi__hint">Un angle = un changement de direction.</span>' +
        '</div>' +

        '<div class="moo-lumi__field">' +
          '<label class="moo-lumi__field-label">Distance jusqu\'à la prise électrique</label>' +
          '<div class="moo-lumi__inputwrap">' +
            '<input type="number" class="moo-lumi__input moo-lumi__distance" data-systeme="' + num + '" min="0" max="2000" step="1" placeholder="ex : 100" inputmode="numeric" />' +
            '<span class="moo-lumi__unit">cm</span>' +
          '</div>' +
          '<span class="moo-lumi__hint">Mesurez entre la fin du bandeau LED et votre prise. Un câble de 1,5 m est inclus, nous ajoutons des rallonges au-delà si nécessaire.</span>' +
        '</div>' +

        '<div class="moo-lumi__field">' +
          '<label class="moo-lumi__field-label">Mode d\'allumage</label>' +
          '<div class="moo-lumi__options moo-lumi__allumage" data-systeme="' + num + '">' +
            '<label class="moo-lumi__opt"><input type="radio" name="moo-lumi-allumage-' + num + '" value="detecteur" checked><span class="moo-lumi__opt-box">Détecteur de mouvement</span></label>' +
            '<label class="moo-lumi__opt"><input type="radio" name="moo-lumi-allumage-' + num + '" value="tactile"><span class="moo-lumi__opt-box">Interrupteur tactile</span></label>' +
          '</div>' +
        '</div>' +

        '<div class="moo-lumi__field">' +
          '<label class="moo-lumi__field-label">Température de couleur</label>' +
          '<div class="moo-lumi__options moo-lumi__couleur" data-systeme="' + num + '">' +
            '<label class="moo-lumi__opt"><input type="radio" name="moo-lumi-couleur-' + num + '" value="chaud" checked><span class="moo-lumi__opt-box">Blanc chaud 2700K</span></label>' +
            '<label class="moo-lumi__opt"><input type="radio" name="moo-lumi-couleur-' + num + '" value="naturel"><span class="moo-lumi__opt-box">Blanc naturel 4000K</span></label>' +
          '</div>' +
        '</div>' +

      '</div>';
  }

  // Memorise les valeurs deja saisies pour ne pas les perdre quand on change le nb de systemes
  var systemesValues = {};
  function snapshotSystemes(root) {
    root.querySelectorAll('.moo-lumi__system').forEach(function(el) {
      var n = el.dataset.systeme;
      var distEl = el.querySelector('.moo-lumi__distance');
      systemesValues[n] = {
        longueur: el.querySelector('.moo-lumi__longueur').value,
        distance: distEl ? distEl.value : '',
        angles: (el.querySelector('input[name="moo-lumi-angles-' + n + '"]:checked') || {}).value || '0',
        allumage: (el.querySelector('input[name="moo-lumi-allumage-' + n + '"]:checked') || {}).value || 'detecteur',
        couleur: (el.querySelector('input[name="moo-lumi-couleur-' + n + '"]:checked') || {}).value || 'chaud'
      };
    });
  }
  function restoreSystemes(root) {
    Object.keys(systemesValues).forEach(function(n) {
      var s = systemesValues[n];
      var longInput = root.querySelector('.moo-lumi__longueur[data-systeme="' + n + '"]');
      if (longInput && s.longueur) longInput.value = s.longueur;
      var distInput = root.querySelector('.moo-lumi__distance[data-systeme="' + n + '"]');
      if (distInput && s.distance) distInput.value = s.distance;
      ['angles','allumage','couleur'].forEach(function(field) {
        var r = root.querySelector('input[name="moo-lumi-' + field + '-' + n + '"][value="' + s[field] + '"]');
        if (r) r.checked = true;
      });
    });
  }

  // ============================================================
  // CALCUL
  // ============================================================
  function calculerSysteme(num, root) {
    var sysEl = root.querySelector('.moo-lumi__system[data-systeme="' + num + '"]');
    if (!sysEl) return null;
    var longueur = parseInt(sysEl.querySelector('.moo-lumi__longueur').value, 10);
    if (!longueur || longueur <= 0) return null;

    var distanceEl = sysEl.querySelector('.moo-lumi__distance');
    var distance = parseInt(distanceEl ? distanceEl.value : '', 10);
    if (isNaN(distance) || distance < 0) distance = 0;

    var angles = parseInt(sysEl.querySelector('input[name="moo-lumi-angles-' + num + '"]:checked').value, 10);
    var allumage = sysEl.querySelector('input[name="moo-lumi-allumage-' + num + '"]:checked').value;
    var couleur = sysEl.querySelector('input[name="moo-lumi-couleur-' + num + '"]:checked').value;

    var nbBandeaux = Math.ceil(longueur / LONGUEUR_BANDEAU_CM);
    var bandeauHandle = (couleur === 'chaud') ? HANDLES.bandeau_chaud : HANDLES.bandeau_naturel;
    var nbConnI = Math.max(0, Math.ceil(longueur / SEUIL_CONN_I_CM) - 1);
    var nbConnL = angles;

    var nbCables = 0;
    if (distance > CABLE_INCLUS_CM) {
      nbCables = Math.ceil((distance - CABLE_INCLUS_CM) / CABLE_RALLONGE_CM);
    }

    var longueurFacturee = nbBandeaux * LONGUEUR_BANDEAU_CM;
    var puissanceNecessaire = (longueurFacturee / 100) * W_PAR_METRE * MARGE_ALIM;
    var alimChoisie = null;
    for (var i = 0; i < ALIMS.length; i++) {
      if (ALIMS[i].w >= puissanceNecessaire) { alimChoisie = ALIMS[i]; break; }
    }
    if (!alimChoisie) alimChoisie = ALIMS[ALIMS.length - 1];

    var detecteurHandle = (allumage === 'detecteur') ? HANDLES.detecteur_motion : HANDLES.detecteur_tactile;

    return {
      num: num,
      longueur: longueur,
      longueurFacturee: longueurFacturee,
      distance: distance,
      angles: angles,
      items: [
        { key: 'bandeau',   handle: bandeauHandle,          qty: nbBandeaux },
        { key: 'connI',     handle: HANDLES.connecteur_i,   qty: nbConnI },
        { key: 'connL',     handle: HANDLES.connecteur_l,   qty: nbConnL },
        { key: 'cable',     handle: HANDLES.cable_rallonge, qty: nbCables },
        { key: 'alim',      handle: alimChoisie.handle,     qty: 1 },
        { key: 'detecteur', handle: detecteurHandle,        qty: 1 }
      ].filter(function(it) { return it.qty > 0; })
    };
  }

  function calculerTout(root) {
    var nb = parseInt(root.querySelector('input[name="moo-lumi-nb-systemes"]:checked').value, 10);
    var systemes = [];
    var aucunSysteme = true;
    for (var i = 1; i <= nb; i++) {
      var s = calculerSysteme(i, root);
      if (s) { systemes.push(s); aucunSysteme = false; }
      else systemes.push(null);
    }
    if (aucunSysteme) return null;
    return systemes;
  }

  // ============================================================
  // RENDU PRINCIPAL
  // ============================================================
  function renderUI(root) {
    root.innerHTML = ''
      + '<div class="moo-lumi">'
      +   '<div class="moo-lumi__hero">'
      +     '<img src="https://cdn.shopify.com/s/files/1/0970/2427/8860/files/FM8011BI61304_5227067_SZ6_1_1.jpg?v=1779308292" alt="Éclairage LED moood en situation" loading="eager" />'
      +     '<img src="https://cdn.shopify.com/s/files/1/0970/2427/8860/files/FM7897BI61182_5227517_SZ6.jpg?v=1779200242" alt="Éclairage LED sous meubles hauts" loading="eager" />'
      +     '<img src="https://cdn.shopify.com/s/files/1/0970/2427/8860/files/FM8011BI61331_5227067_SZ6.jpg?v=1779196813" alt="Éclairage LED ambiance cuisine" loading="eager" />'
      +   '</div>'
      +   '<div class="moo-lumi__notice">'
      +     '<span class="moo-lumi__notice-icon">i</span>'
      +     '<div class="moo-lumi__notice-text">Bien que les bandeaux LED soient vendus par tranches de 60&nbsp;cm, <strong>votre éclairage est découpé sur mesure et livré à la taille exacte que vous avez saisie, au millimètre près</strong>. Aucune coupe à prévoir chez vous.</div>'
      +   '</div>'

      +   '<div class="moo-lumi__step">'
      +     '<h3><span class="moo-lumi__step-num">1</span><span class="moo-lumi__step-title">Combien de systèmes d\'éclairage indépendants ?</span></h3>'
      +     '<div class="moo-lumi__chips" id="moo-lumi-nb-systemes-wrap">'
      +       '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-nb-systemes" value="1" checked><span class="moo-lumi__chip-box">1</span></label>'
      +       '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-nb-systemes" value="2"><span class="moo-lumi__chip-box">2</span></label>'
      +       '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-nb-systemes" value="3"><span class="moo-lumi__chip-box">3</span></label>'
      +       '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-nb-systemes" value="4"><span class="moo-lumi__chip-box">4</span></label>'
      +       '<label class="moo-lumi__chip"><input type="radio" name="moo-lumi-nb-systemes" value="5"><span class="moo-lumi__chip-box">5</span></label>'
      +     '</div>'
      +     '<span class="moo-lumi__hint">Un système = une zone d\'éclairage avec sa propre alimentation. Choisissez 2 si vous avez par exemple 2 murs de meubles hauts qui ne se touchent pas.</span>'
      +   '</div>'

      +   '<div id="moo-lumi-systemes-container"></div>'

      +   '<div class="moo-lumi__recap-inline" id="moo-lumi-recap-inline">'
      +     '<h3 class="moo-lumi__recap-title">Récapitulatif de l\'éclairage</h3>'
      +     '<div id="moo-lumi-recap-content"><p class="moo-lumi__empty">Renseignez la longueur à éclairer pour voir le détail.</p></div>'
      +     '<button type="button" class="moo-lumi__cta" id="moo-lumi-add-btn" disabled>Ajouter au pack</button>'
      +   '</div>'

      + '</div>';

    renderSystemes(root);

    // Listeners
    root.addEventListener('change', function(e) {
      if (e.target.name === 'moo-lumi-nb-systemes') {
        renderSystemes(root);
      } else if (e.target.matches('input[type="radio"]') && e.target.name && e.target.name.indexOf('moo-lumi-nb-systemes') !== 0) {
        rendreRecap(root);
      }
    });
    root.addEventListener('input', function(e) {
      if (e.target.classList && (e.target.classList.contains('moo-lumi__longueur') || e.target.classList.contains('moo-lumi__distance'))) {
        rendreRecap(root);
      }
    });

    var addBtn = root.querySelector('#moo-lumi-add-btn');
    if (addBtn) addBtn.addEventListener('click', function() { ajouterAuPack(root); });
  }

  function renderSystemes(root) {
    snapshotSystemes(root);
    var nb = parseInt(root.querySelector('input[name="moo-lumi-nb-systemes"]:checked').value, 10);
    var container = root.querySelector('#moo-lumi-systemes-container');
    var html = '';
    for (var i = 1; i <= nb; i++) html += htmlSysteme(i);
    container.innerHTML = html;
    restoreSystemes(root);
    rendreRecap(root);
  }

  function rendreRecap(root) {
    var systemes = calculerTout(root);
    var content = root.querySelector('#moo-lumi-recap-content');
    var btn = root.querySelector('#moo-lumi-add-btn');

    if (!systemes) {
      content.innerHTML = '<p class="moo-lumi__empty">Renseignez la longueur à éclairer pour voir le détail.</p>';
      btn.disabled = true;
      return;
    }

    var allHandles = [];
    systemes.forEach(function(s) {
      if (!s) return;
      s.items.forEach(function(it) { if (allHandles.indexOf(it.handle) === -1) allHandles.push(it.handle); });
    });

    Promise.all(allHandles.map(fetchProduct)).then(function() {
      var total = 0;
      var html = '';
      var nbSystemesActifs = 0;

      systemes.forEach(function(s) {
        if (!s) return;
        nbSystemesActifs++;
        html += '<div class="moo-lumi__recap-section">';
        html += '<p class="moo-lumi__recap-section-title">Système ' + s.num + ' · ' + s.longueur + ' cm</p>';
        html += '<ul class="moo-lumi__recap-list">';
        s.items.forEach(function(it) {
          var p = productCache[it.handle];
          if (!p) return;
          var sousTotal = p.price * it.qty;
          total += sousTotal;
          html += '<li class="moo-lumi__recap-item">';
          html += '<div class="moo-lumi__recap-name"><strong>' + escapeHtml(p.title) + '</strong>';
          html += '<span class="moo-lumi__recap-qty">' + it.qty + ' × ' + fmtPrix(p.price) + '</span></div>';
          html += '<div class="moo-lumi__recap-price">' + fmtPrix(sousTotal) + '</div>';
          html += '</li>';
        });
        html += '</ul>';
        html += '<p class="moo-lumi__recap-note">Découpé sur mesure et livré à <strong>' + s.longueur + ' cm</strong> exact (mm près).</p>';
        html += '</div>';
      });

      if (nbSystemesActifs === 0) {
        content.innerHTML = '<p class="moo-lumi__empty">Renseignez la longueur à éclairer pour voir le détail.</p>';
        btn.disabled = true;
        return;
      }

      html += '<div class="moo-lumi__recap-total"><span>Total éclairage</span><span class="moo-lumi__recap-total-price">' + fmtPrix(total) + '</span></div>';
      content.innerHTML = html;
      btn.disabled = false;
      btn.dataset.config = JSON.stringify(systemes);
    }).catch(function(err) {
      content.innerHTML = '<p class="moo-lumi__empty">Une erreur est survenue lors du chargement des produits.</p>';
      btn.disabled = true;
      console.error('[moo-lumi]', err);
    });
  }

  // ============================================================
  // AJOUT AU PACK (push dans window.mooodState.panier)
  // ============================================================
  function ajouterAuPack(root) {
    var btn = root.querySelector('#moo-lumi-add-btn');
    var raw = btn.dataset.config;
    if (!raw) return;
    var systemes = JSON.parse(raw);

    var state = window.mooodState;
    if (!state) {
      console.error('[moo-lumi] window.mooodState introuvable');
      return;
    }

    // Agreger les quantites par handle (pour ne pas avoir 2 lignes du meme produit)
    var qtyByHandle = {};
    systemes.forEach(function(s) {
      if (!s) return;
      s.items.forEach(function(it) {
        qtyByHandle[it.handle] = (qtyByHandle[it.handle] || 0) + it.qty;
      });
    });

    // Recuperer infos produits puis pousser dans le panier
    var handles = Object.keys(qtyByHandle);
    Promise.all(handles.map(fetchProduct)).then(function(produits) {
      // D'abord, on retire les eventuels anciens items luminaire du panier (collection ETAPE_HANDLE)
      // pour ne pas cumuler les anciens calculs
      for (var i = state.panier.length - 1; i >= 0; i--) {
        if (state.panier[i].collection === ETAPE_HANDLE) {
          state.panier.splice(i, 1);
        }
      }

      // Pousser les nouveaux items
      produits.forEach(function(p, idx) {
        if (!p || !p.variantId) return;
        var handle = handles[idx];
        var qty = qtyByHandle[handle];
        state.panier.push({
          productId: p.id,
          variantId: p.variantId,
          name: p.title,
          color: '',
          price: p.price / 100,
          image: typeof p.image === 'string' ? p.image : (p.image && p.image.src) || '',
          qty: qty,
          collection: ETAPE_HANDLE
        });
      });

      // Forcer le re-render du panier via le configurateur general
      if (typeof window.mooodRenderPanier === 'function') {
        window.mooodRenderPanier();
      } else {
        // Fallback : declenche un re-render en passant par renderPanier interne
        // (le configurateur general met a jour le panier sur tout evenement de change)
        var evt = new CustomEvent('moood:luminaire-added');
        document.dispatchEvent(evt);
      }

      // Marquer l'etape comme active (verte) dans la pill
      var pill = document.querySelector('.moood-etape[data-etape="' + ETAPE_HANDLE + '"]');
      if (pill) pill.classList.add('active');

      // Feedback bouton
      btn.textContent = '✓ Ajouté au pack !';
      btn.disabled = true;
      setTimeout(function() {
        btn.textContent = 'Ajouter au pack';
        btn.disabled = false;
      }, 2000);
    }).catch(function(err) {
      console.error('[moo-lumi]', err);
      btn.textContent = 'Erreur, réessayez';
      setTimeout(function() {
        btn.textContent = 'Ajouter au pack';
        btn.disabled = false;
      }, 2500);
    });
  }

  // ============================================================
  // OBSERVER : detecter quand l'etape Luminaire est active
  // ============================================================
  function maybeRenderLuminaire() {
    var pill = document.querySelector('.moood-etape[data-etape="' + ETAPE_HANDLE + '"]');
    if (!pill) return;
    if (!pill.classList.contains('current')) return;

    var section = document.getElementById('moood-products-sections');
    if (!section) return;

    // Si on a deja injecte notre UI dans cette section, ne rien faire
    if (section.querySelector('.moo-lumi')) return;

    // Sinon, on prend le controle : on vide la section et on injecte notre UI
    injectStyles();
    section.innerHTML = '';
    renderUI(section);
    preloadAllProducts();
  }

  // Polling leger : on observe les mutations sur la barre d'etapes
  function startObserver() {
    var target = document.getElementById('moood-etapes');
    if (!target) {
      // Pas encore en DOM, on retente
      setTimeout(startObserver, 500);
      return;
    }
    var observer = new MutationObserver(function() {
      maybeRenderLuminaire();
    });
    observer.observe(target, { attributes: true, childList: true, subtree: true });

    // Aussi observer la section produits pour le cas ou elle est re-render par le gros configurateur
    var section = document.getElementById('moood-products-sections');
    if (section) {
      var observer2 = new MutationObserver(function() {
        maybeRenderLuminaire();
      });
      observer2.observe(section, { childList: true });
    }

    // Premier check
    maybeRenderLuminaire();
  }

  // ============================================================
  // INIT
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
